import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '../../../../../generic-components/Heading';
import { useStore } from '../../../../../store';
import { CloseButton, CloseButtonSize } from '../../../../../DesignSystem/LiliCloseButton/CloseButton';

interface IProps {
  onClose: () => void;
}

export const BillPreview = ({ onClose }: IProps) => {
  const { billData } = useStore((state) => state);
  const { t } = useTranslation();
  const isPdf = useMemo(() => !!billData.assetType.includes('pdf'), [billData.assetType]);
  return (
    <div className='w-full h-full flex flex-col bg-bw00'>
      <div className='flex items-center justify-between py-[16px] px-[16px] bg-bw00 border-b border-bw03'>
        <CloseButton onClick={onClose} id='closePreviewModal' size={CloseButtonSize.Large} />
        <Heading title={t('CREATE_BILL.BILL_PREVIEW')} className='font-metricRMedium text-bw08 text-[18px]' />
        <span />
      </div>
      <div className='py-[28px] px-[28px] bg-bw00'>
        <div className='border border-bw03 rounded-[8px]'>
          {isPdf ? (
            <iframe
              className='w-full h-full object-fill rounded-[8px] py-[4px] px-[4px]'
              src={billData.billImageUrl}
              title='bill-preview'
            />
          ) : (
            <img
              className='w-full h-full object-fill rounded-[8px] py-[4px] px-[4px]'
              src={billData.billImageUrl}
              alt='bill-preview'
            />
          )}
        </div>
      </div>
    </div>
  );
};
